export const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!CLERK_PUBLISHABLE_KEY) {
  console.error(
    "Error: REACT_APP_CLERK_PUBLISHABLE_KEY is missing in .env file."
  );
}

export const API_BASE_URL = process.env.REACT_APP_API_URL;

export const apiurl = `${API_BASE_URL}/api`;
export const staticurl = `${API_BASE_URL}/`;